// extracted by mini-css-extract-plugin
module.exports = {"breakpoint":"(max-width: 900px)","hello":"Header_hello_2s-E7","mobileMenu":"Header_mobileMenu_32P8x"};